/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import ArgosFlexbox from '../../../../../../../components/Containers/ArgosFlexbox';
import ArgosButton from '../../../../../../../components/Buttons/ArgosButton';
import { set } from 'lodash';
import { defaultXLabel, defaultYLabel } from './constants';

interface AxisDropdownProps {
    selectedXAxis: { variable_name: string, display_name: string },
    selectedYAxis: { variable_name: string, display_name: string },
    handleXAxisChange: Function;
    handleYAxisChange: Function;
    doeNameMap: Map<string, string>
}

const AxisDropdown: React.FC<AxisDropdownProps> = (props: AxisDropdownProps) => {
    const [XYSelection, setXYSelection] = React.useState<{ x: string, y: string }>({ x: props.selectedXAxis.variable_name, y: props.selectedYAxis.variable_name });
    const handleYSelectionChange = (event: SelectChangeEvent<string>, child: React.ReactNode) => {
        setXYSelection({ ...XYSelection, y: event.target.value });
    }
    const handleXSelectionChange = (event: SelectChangeEvent<string>, child: React.ReactNode) => {
        setXYSelection({ ...XYSelection, x: event.target.value });
    }
    const update = () => {
        props.handleXAxisChange(XYSelection.x);
        props.handleYAxisChange(XYSelection.y);
    }

    return (
        <ArgosFlexbox>
            {/* Parameter Dropdowns TODO this still always gets actor.d_lat and long currently*/}
            <ArgosFlexbox vertical style={{marginTop: 10}}>
                <FormControl fullWidth>
                    <InputLabel id="global_X_axis">X Axis</InputLabel>
                    <Select
                        labelId="global_X_axis"
                        label="X Axis"
                        type="text"
                        value={XYSelection.x}
                        id="global_x_axis"
                        onChange={handleXSelectionChange}
                    >
                        {
                            Array.from(props.doeNameMap.entries()).map(([variable_name, display_name]) => {
                                return <MenuItem key={variable_name} value={variable_name}>{display_name}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel id="global_Y_axis">Y Axis</InputLabel>
                    <Select
                        label="Y Axis"
                        labelId="global_Y_axis"
                        type="text"
                        value={XYSelection.y}
                        id="global_Y_axis"
                        onChange={handleYSelectionChange}
                    >
                        {
                            Array.from(props.doeNameMap.entries()).map(([variable_name, display_name]) => {
                                return <MenuItem key={variable_name} value={variable_name}>{display_name}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
                <ArgosButton onClick={update}>UPDATE PLOT AXES</ArgosButton>
                <ArgosButton onClick={
                    () => {
                        setXYSelection({ x: defaultXLabel.variable_name, y: defaultYLabel.variable_name });
                        props.handleXAxisChange(defaultXLabel.variable_name);
                        props.handleYAxisChange(defaultYLabel.variable_name);
                    }
                }>RESTORE DEFAULT AXES</ArgosButton>
            </ArgosFlexbox>
        </ArgosFlexbox>
    );
};

export default AxisDropdown;